<div #root class="overlay-shell">
  <ng-container
    *ngComponentOutlet="context.component; injector: componentInjector"
  ></ng-container>
</div>
